import { getSetting } from '@onepos/shared';
import { Badge, Card, EmptyState } from '@onepos/ui';
import { fmtDateTime } from '../../lib/format';
import { settingValueText } from '../../lib/settings';
import type { TenantDetail } from '../../lib/types';
import { AuditList } from '../../components/AuditList';

const WHO: Record<string, string> = { platform: 'Platforma', member: 'Ega', staff: 'Xodim', system: 'Tizim' };

function valueText(key: string, v: unknown): string {
  const def = getSetting(key);
  if (v === null || v === undefined) return '—';
  return def ? settingValueText(def, v) : JSON.stringify(v);
}

export function HistoryTab({ data }: { data: TenantDetail }) {
  return (
    <div className="cn-two">
      <Card title="Platforma amallari">
        {data.audit.length === 0 ? <EmptyState title="Hali amal yo‘q" /> : <AuditList items={data.audit} />}
      </Card>
      <Card title="Sozlamalar tarixi">
        {data.settings_history.length === 0 ? (
          <EmptyState title="O‘zgarish yo‘q" />
        ) : (
          <ol className="cn-audit">
            {data.settings_history.map((h) => (
              <li key={h.id}>
                <span className="cn-audit__time op-num">{fmtDateTime(h.created_at)}</span>
                <span className="cn-audit__what">
                  <strong>{getSetting(h.key)?.label ?? h.key}</strong>
                  <span className="cn-audit__detail">
                    {valueText(h.key, h.old_value)} → {valueText(h.key, h.new_value)}
                    {h.reason ? ` · ${h.reason}` : ''}
                  </span>
                </span>
                <span className="cn-audit__who">
                  <Badge tone="neutral">{WHO[h.changed_by_kind] ?? h.changed_by_kind}</Badge>
                </span>
              </li>
            ))}
          </ol>
        )}
      </Card>
      <Card title="Yordam sessiyalari">
        {data.support_sessions.length === 0 ? (
          <EmptyState title="Yordam sessiyasi bo‘lmagan" />
        ) : (
          <ol className="cn-audit">
            {data.support_sessions.map((s) => (
              <li key={s.id}>
                <span className="cn-audit__time op-num">{fmtDateTime(s.started_at)}</span>
                <span className="cn-audit__what">
                  <strong>{s.mode === 'write' ? 'Sozlash' : 'Ko‘rish'}</strong>
                  <span className="cn-audit__detail">{s.reason ?? ''}</span>
                </span>
                <span className="cn-audit__who">{s.admin_name ?? '—'}</span>
              </li>
            ))}
          </ol>
        )}
      </Card>
    </div>
  );
}
